import * as designTokens from './sizing';

export const sizing = {
  ...designTokens,
};
